import { Icon } from '../../icon/icon';
import './SectionInstallationInfo.scss';
import { Trans, useTranslation } from 'react-i18next';

const SectionInstallationInfo = () => {
  const { t } = useTranslation();
  return (
    <section className="flex lg:py-[40px] lg:px-[80px] md:px-[20px] px-[16px] py-[32px] bg-fills-white">
      <div className="lg:grid lg:grid-cols-2 flex flex-col grow lg:gap-[40px] gap-[16px]">
        <div className="flex flex-col lg:gap-[40px] gap-[16px] items-start grow self-stretch">
          <span className="lg:h1 text-headline-small !font-bold">
            <Trans
              i18nKey={'Constant.Easy assembly. Straightforward pricing.'}
              components={{
                br: <br />,
              }}
            />
          </span>
          <div className="flex flex-col items-start self-stretch">
            <div className="flex lg:p-[24px] p-[16px] items-start gap-[24px] self-stretch border-b-[1px] border-solid border-[#E0E0E0]">
              <span className="flex py-[8px] px-[16px] justify-center items-center gap-[8px] rounded-[6px] h-[40px] bg-primary-primary text-white">
                <Icon.ICTool />
              </span>
              <div className="flex flex-col items-start gap-8 grow">
                <span className="text-title-large !font-bold">
                  {t('Constant.Self-installation')}
                </span>
                <span className="text-body-medium">
                  {t('Constant.DIY with step-by-step instructions.')}
                </span>
              </div>
            </div>
            <div className="flex lg:p-[24px] p-[16px] items-start gap-[24px] self-stretch lg:border-b-[1px] border-none lg:border-solid border-[#E0E0E0]">
              <span className="flex py-[8px] px-[16px] justify-center items-center gap-[8px] rounded-[6px] h-[40px] bg-primary-primary text-white">
                <Icon.ICEngineering />
              </span>
              <div className="flex flex-col items-start gap-8 grow">
                <span className="text-title-large !font-bold">
                  {t('Constant.Fitta installation')}
                </span>
                <span className="text-body-medium">
                  {t('Constant.Delivered and installed by the Fitta team')}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex lg:h-[424px] md:h-[585px] h-[296px] items-start gap-[40px] grow ">
          <div className="flex flex-col items-end grow self-stretch rounded-[24px] bg-[#F5F5F5] overflow-hidden">
            <img
              src="https://d391nxox3m93fb.cloudfront.net/fitta_site_images/assembly.webp"
              alt={t('Constant.Easy installation - Affordable pricing')}
              className="object-cover w-full h-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionInstallationInfo;
